<template>
	<client-only>
		<v-tooltip
			v-model="showTooltip"
			class="global-tooltip"
			:location="location ? location : 'bottom'"
			v-bind="$attrs"
			:text="text"
			content-class="global-tooltip"
			:open-on-hover="!touch"
			:open-on-click="touch"
			scroll-strategy="close"
			:style="maxWidth && `--test: ${maxWidth}px`"
			@click:outside="showTooltip = false">
			<template #activator="{ props }">
				<slot />
				<GlobalIcon
					class="global-tooltip__icon"
					:class="{ 'global-tooltip__icon-black': blackIcon }"
					:width="iconWidth ? iconWidth : 18"
					name="tooltip"
					v-bind="props"></GlobalIcon>
			</template>
		</v-tooltip>
	</client-only>
</template>

<script lang="ts" setup>
defineProps<{
	text: string
	blackIcon?: boolean
	iconWidth?: number
	location?: 'top' | 'bottom' | 'left' | 'right'
	maxWidth?: number | string
}>()

const touch = ref(false)
const showTooltip = ref(false)
onBeforeMount(() => {
	touch.value = matchMedia('(hover: none), (pointer: coarse)').matches
})
</script>

<style lang="scss">
@import './Tooltip.scss';
</style>
